import { useTranslation } from 'react-i18next';

export const useGetVideosInfo = () => {
    const { t } = useTranslation();

    return [
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Red.mp4',
            id: '1',
            title: t('danceShow.redShow.title'),
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/redDanceThumb.jpg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Black.mp4',
            id: '2',
            title: t('danceShow.blackShow.title'),
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/blackDanceThumb.jpg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/discoShow.mp4',
            id: '3',
            title: t('danceShow.discoShow.title'),
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/discoDanceThumb.jpg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/goldenBeats.mp4',
            id: '4',
            title: t('danceShow.goldenBeatsShow.title'),
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/goldenBeatsThumb.jpg',
        },
    ];
};

export const useGetVideosInfo2 = () => {
    return [
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20251.mp4',
            id: '1',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Samadhi1.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20252.mp4',
            id: '2',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Yacht+show.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20253.mp4',
            id: '3',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Wedding+Eric.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20254.mp4',
            id: '4',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Li+Sam.webp',
        },
    ];
};

export const useGetVideosInfo3 = () => {
    return [
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20255.mp4',
            id: '1',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Noel.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20256.MP4',
            id: '2',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Formula1.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20257.MOV.mp4',
            id: '3',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Merci+ships+gala.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20258.mp4',
            id: '4',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Imperia+event.webp',
        },
    ];
};

export const useGetVideosInfo4 = () => {
    return [
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video20259.mp4',
            id: '1',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Wedding+Antonio.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/video202510.mp4',
            id: '2',
            title: '',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/blackDanceThumb.jpg',
        },
    ];
};
